module.exports = {
      id: "listary_4_icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "images/js_src_vue/page_listary_landing/sprite.d9b7df9a.svg#listary_4_icon-usage",
      toString: function () {
        return this.url;
      }
    }